import React from 'react';
import generateUserAgreement from '../userAgreement';

function AgreementModal({ onClose, name, company, email }) {
  const agreementText = generateUserAgreement({
    name,
    company,
    email,
    date: new Date().toLocaleDateString('tr-TR'),
  });

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Kullanıcı Sözleşmesi</h2>
        <div
          className="agreement-text"
          style={{
            maxHeight: '60vh',
            overflowY: 'auto',
            fontSize: '14px',
            whiteSpace: 'pre-wrap',
            textAlign: 'left',
            marginBottom: '1rem',
          }}
        >
          {agreementText}
        </div>
        <button onClick={onClose} className="register-btn">
          Kapat
        </button>
      </div>
    </div>
  );
}

export default AgreementModal;
